<template>
  <div class="container">
    <van-search v-model="value" show-action clearable @clear="onSearch" placeholder="请输入搜索手机号">
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <div class="list" v-for="item in list">
      <div>
        <span class="name">{{ item.userName }}</span> <span>{{ item.userPhone }}</span>
      </div>
      <div>{{ item.prizeName }}</div>
      <div>{{ item.updateTime }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "business",
  components: {},
  data() {
    return {
      list: [],
      value: "",
      raffle: 1,
    };
  },
  created() {
    let { raffle } = this.$route.query;
    this.raffle = raffle || 1;
    document.title = "三一云联";
    this.onSearch();
  },
  methods: {
    onSearch() {
      let data = {
        lotteryActivityId: this.raffle,
      };
      if (this.value) {
        data["phone"] = this.value;
      }
      this.$api.getLotteryHistory(data).then((res) => {
        if (res.data.code == 0) {
          this.list = res.data.data; // res.data.data.reverse()
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  .list {
    width: 100%;
    background-color: #eee;
    margin: 5px 0;
    padding: 5px 0;
    div {
      padding: 4px 10px;
      font-size: 16px;
      color: #666;
    }
    .name {
      color: #333;
      font-size: 18px;
      margin-right: 10px;
    }
    .van-cell {
      height: 2rem;
      .van-cell__value {
        width: 70%;
      }
    }
  }
}
</style>
